import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FabrikatDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fabrikat-dto';
import { Observable, BehaviorSubject, Subject, ReplaySubject } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { startWith, map, takeUntil } from 'rxjs/operators';
import { StamdataStatusEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/stamdata-status-enum';

@Component({
    selector: 'app-fabrikat-input',
    templateUrl: './fabrikat-input.component.html',
    styleUrls: ['./fabrikat-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FabrikatInputComponent implements OnInit, OnDestroy {
  private _fabrikater = new BehaviorSubject<FabrikatDto[]>([]);
  @Input() set fabrikater(value: FabrikatDto[]) {
    this._fabrikater.next(value);
  }

  @Input() form: UntypedFormGroup;

  @Output() fabrikatChange: EventEmitter<FabrikatDto> = new EventEmitter();

  get fabrikater() {
    return this._fabrikater.getValue();
  }

  filteredFabrikater: Observable<FabrikatDto[]>;

  _selectedFabrikat$: ReplaySubject<string> = new ReplaySubject();

  @Input()
  set selectFabrikat$(val: ReplaySubject<string>) {
    this._selectedFabrikat$ = val;
  }

  selectedFabrikat: string;

  @Input() appearance: string = 'outline';

  fabrikatCtrl = new UntypedFormControl();
  @ViewChild('fabrikatInput') fabrikatInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', { read: MatAutocompleteTrigger }) matAutocomplete: MatAutocomplete;
  autocompleteTrigger: MatAutocompleteTrigger;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  visible = true;

  fabrikatStatusEnum = StamdataStatusEnum;

  unsubscribe$ = new Subject<void>();

  constructor() {}

  ngOnInit(): void {
    this._selectedFabrikat$.pipe(takeUntil(this.unsubscribe$)).subscribe((fabrikat: string) => {
      if (fabrikat && fabrikat.trim() !== '') {
        this.selectedFabrikat = fabrikat;
      }
    });

    this._fabrikater.subscribe(() => {
      this.filteredFabrikater = this.fabrikatCtrl.valueChanges.pipe(
        takeUntil(this.unsubscribe$),
        startWith(null),
        map((fabrikat: string | null) => (fabrikat ? this._filter(fabrikat) : this.fabrikater.slice().map((y) => y)))
      );
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  addFabrikat(event: MatChipInputEvent): void {
    const input = event.chipInput.inputElement;
    const value = event.value;
    const fabrikat = this.fabrikater.find((x) => x.name == value);

    if (this.selectedFabrikat && value) {
      this._selectedFabrikat$.next(fabrikat.name);
      this.fabrikatChange.emit(fabrikat);
    }

    // Reset the input value
    if (input) {
      input.value = null;
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const fabrikat = this.fabrikater.find((x) => x.name == event.option.value);
    this._selectedFabrikat$.next(fabrikat.name);
    this.fabrikatInput.nativeElement.value = '';
    this.fabrikatChange.emit(fabrikat);
    this.fabrikatCtrl.setValue(null);
  }

  private _filter(value: string): FabrikatDto[] {
    const filterValue = value.toLowerCase();
    return this.fabrikater
      .map((x) => x)
      .filter((fabrikat) => fabrikat.name.toLowerCase().indexOf(filterValue) === 0 && fabrikat !== this.selectedFabrikat);
  }
}
